import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Shield, MessageCircle } from 'lucide-react';

const WhistleblowerSectionEn = () => {
  return <section className="py-20 bg-gradient-to-br from-[hsl(var(--focus-areas-start))] via-[hsl(var(--focus-areas-mid))] to-[hsl(var(--focus-areas-end))]">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12">
            <div className="flex justify-center mb-6">

            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              Help Us Improve the Ecosystem
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Your voice matters. Help us identify what's not working in Sweden's startup ecosystem so we can work together to create positive change.
            </p>
          </div>

          <Card className="bg-white shadow-xl border-0 mb-8">
            <CardContent className="p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="text-left">
                  <h3 className="text-2xl font-bold mb-4 text-black">What's Not Working?</h3>
                  <p className="text-gray-700 mb-6">
                    We're committed to transparency and continuous improvement. If you've encountered issues, barriers, or problems within the startup ecosystem, we want to hear about it.
                  </p>

                  <div className="space-y-3 mb-6">
                    <h4 className="font-semibold text-gray-900">Common Issues Include:</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>• Discrimination or bias in funding processes</li>
                      <li>• Regulatory barriers and bureaucratic obstacles</li>
                      <li>• Unfair business practices</li>
                      <li>• Access barriers for underrepresented groups</li>
                      <li>• Systemic issues affecting startup growth</li>
                    </ul>
                  </div>
                </div>

                <div className="text-left">
                  <h3 className="text-2xl font-bold mb-4 text-black">Your Privacy is Protected</h3>
                  <div className="flex items-start space-x-3 mb-4">
                    <Shield className="h-6 w-6 text-blue-600 mt-1" />
                    <div>
                      <h4 className="font-semibold text-gray-900">Complete Anonymity</h4>
                      <p className="text-gray-600">Reports can be submitted completely anonymously with no personal information required.</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 mb-4">
                    <MessageCircle className="h-6 w-6 text-blue-600 mt-1" />
                    <div>
                      <h4 className="font-semibold text-gray-900">Confidential Review</h4>
                      <p className="text-gray-600">All reports are reviewed confidentially and used to improve ecosystem conditions.</p>
                    </div>
                  </div>

                  <div className="p-4 bg-blue-50 rounded-lg">
                    <p className="text-sm text-blue-800 font-medium">
                      Your feedback drives systemic change and helps create a more inclusive, fair startup environment for everyone.
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <Button size="lg" variant="cyan" className="font-semibold px-8 py-3">
                  <AlertTriangle className="w-5 h-5 mr-2" />
                  Report an Issue Confidentially
                </Button>
                <p className="text-sm text-gray-500 mt-3">
                  All reports are handled with complete confidentiality and used to drive positive change.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default WhistleblowerSectionEn;
